import { DateTime } from 'luxon'

const $toMillisecondsDate = function (date = '') {
  return DateTime.fromISO(`${date}`).valueOf()
}

let toMillisecondsDate = {
  install: (app) => {
    app.config.globalProperties.$toMillisecondsDate = $toMillisecondsDate
    app.provide('toMillisecondsDate', $toMillisecondsDate)
  }
}

export default toMillisecondsDate
